import { GeminiChatContext } from "@/contexts/GeminiContext";
import { useContext } from "react";

export const useGeminiChat = () => {
  const context = useContext(GeminiChatContext);
  if (!context) {
    throw new Error("useGeminiChat must be used within a GeminiChatProvider");
  }
  return context;
};
